import { get } from "sites-common/utils/lodash";
import {
  queryPatientsMine,
  patientsConfig,
  postprocessPatients,
  patientsMineSelectors,
  validatePatients,
} from "../../common1/firebase-selectors/patients";
import { RenderColumns, ItemCard } from "./renderItemCard";
import { homeCareAppUrl, patientsMineCareAppUrl } from "../../care-app/urls";

const Config = (
  who_am_i,
  i_am_admin = false,
  trainerOpts = [],
  trainersMap = {},
  trainer
) => {
  const pSelectors = patientsMineSelectors();

  return {
    who_am_i,

    primaryKey: patientsConfig.primaryKey,

    disableEditPrimaryKey: true,

    initialQueries: [queryPatientsMine(who_am_i, trainer)],

    homeUrl: patientsMineCareAppUrl,
    backUrl: homeCareAppUrl,

    sessionKey: "careapp.patients.mine",
    noItemMsg: "No Patients Loaded",
    mainTitle: "My Patients",
    mainTitleIcon: "People",

    pageOptions: {
      "All Patients": {
        optionsSelector: () => [{ key: "all", text: "All Patients" }],
        pageSelector: pSelectors.ordered,
      },
      Status: {
        optionsSelector: pSelectors.valuesGivenKey("status"),
        pageSelector: pSelectors.listGivenKV("status"),
      },
    },

    singleItemSelector: pSelectors.id,
    singleItemDispatcher: null,

    collection: patientsConfig.collection,
    postprocess: postprocessPatients,
    validate: validatePatients,
    formFields: patientsConfig.fields(true, false, trainerOpts, i_am_admin),
    formDefaults: patientsConfig.defaults,
    autogenPrimaryKey: true,

    editBtnText: "Edit",
    newBtnText: "New",
    editBtnType: "action",
    editContainerProps: {
      style: { maxWidth: 350 },
    },

    renderItemCard: ItemCard,
    colDefns: RenderColumns(patientsConfig.primaryKey, trainersMap),
    showTableHeader: true,
    displayAsTable: false,
    tableEditButtonProps: { text: "Edit" },

    panelForNewItem: true,
    panelForEditItem: true,

    filterProps: {
      placeholder: "Patient / City / Trainer",
      searchFunction: (r) =>
        `${JSON.stringify(r.caretrainers) + r.name} ${r.city} ${r.email} ${
          r.country
        } ${r.state}`,
      filterMenuItems: [
        {
          key: "name",
          text: "Name (Ascending)",
          f: (a, b) => a.name.toLowerCase() > b.name.toLowerCase(),
        },
        {
          key: "city",
          text: "City (Ascending)",
          f: (a, b) => a.city.toLowerCase() > b.city.toLowerCase(),
        },
        {
          key: "city_d",
          text: "City (Descending)",
          f: (a, b) => a.city.toLowerCase() < b.city.toLowerCase(),
        },
        {
          key: "country",
          text: "Country/State (Ascending)",
          f: (a, b) =>
            (get(a, "country", "") + get(a, "state", "")).toLowerCase() >
            (get(b, "country", "") + get(b, "state", "")).toLowerCase(),
        },
        {
          key: "d4",
          text: "New Patients",
          f: (a, b) => a.added_on > b.added_on,
          sf: (r) => !r.last_sitting_date,
        },
        {
          key: "d5",
          text: "Days Since Last Sitting",
          f: (a, b) => a.last_sitting_days <= b.last_sitting_days,
          sf: (r) => {
            return !!r.last_sitting_date;
          },
        },
      ],
    },
  };
};
export default Config;
